module.exports = __webpack_public_path__ + "img/deklarachii.d6bf50cb.png";